import api from "@/libs/axios";
import ngoService from "../../services";
import * as endpoints from "../../endpoints";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  namespaced: true,
  state: () => ({
    ngoServices: [],
    status: [],
    services: [],
    serviceFrequencies: [],
    loading: false,
    working: false,
    servicesAndClassifications: [],
  }),
  getters: {
    ngoServices(state) {
      return state.ngoServices;
    },

    status(state) {
      return state.status;
    },

    services(state) {
      return state.services;
    },

    serviceFrequencies(state) {
      return state.serviceFrequencies;
    },
    servicesAndClassifications(state) {
      return state.servicesAndClassifications;
    },
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
  },
  mutations: {
    status(state, payload) {
      state.status = payload;
    },
    setServicesAndClassifications(state, payload) {
      state.servicesAndClassifications = payload;
    },
    ngoServices(state, payload) {
      state.ngoServices = payload;
    },

    services(state, payload) {
      state.services = payload;
    },

    serviceFrequencies(state, payload) {
      state.serviceFrequencies = payload;
    },

    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async getStatus(context) {
      await api.get(endpoints.STATUS).then((res) => {
        context.commit("status", res.data.data);
      });
    },

    async getNgoServices(context) {
      await api.get(endpoints.NGO_SERVICES).then((res) => {
        context.commit("ngoServices", res.data.data);
      });
    },

    async getServices(context) {
      await api.get(endpoints.SERVICES).then((res) => {
        context.commit("services", res.data.data);
      });
    },

    async getServicesFrequency(context) {
      await api.get(endpoints.SERVICE_FREQUENCY).then((res) => {
        context.commit("serviceFrequencies", res.data.data);
      });
    },

    async fetchServicesAndClassifications({ commit }) {
      commit("setLoading", true);
      try {
        const data = await ngoService.fetchServicesAndClassifications();
        commit("setServicesAndClassifications", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },

    async addServiceType({ commit }, payload) {
      const data = await api
        .post(endpoints.SERVICES, payload)
        .then((res) => res.data);

      return Promise.resolve(data);
    },

    async updateService({ commit, dispatch }, payload) {
      commit("setWorking", true);
      await api
        .put(endpoints.NGO_SERVICES + "/" + payload.id, payload)
        .then((res) => {
          dispatch("fetchServicesAndClassifications");

          // if (res.status.ok) {
          //   this.$toast({
          //     component: ToastificationContent,
          //     props: {
          //       title: "Notification",
          //       icon: "BellIcon",
          //       text: "👋 Chocolate oat cake jelly oat cake candy jelly beans pastry.",
          //       variant,
          //     },
          //   });
          // }
        });
      commit("setWorking", false);
    },
    async addNewService({ commit, dispatch }, payload) {
      commit("setWorking", true);
      await api.post(endpoints.NGO_SERVICES, payload).then((res) => {
        dispatch("handleResponse", res);
      });

      commit("setWorking", false);
    },

    async addNewClassification({ commit, dispatch }, payload) {
      commit("setWorking", true);
      await api.post(endpoints.NGO_CLASSIFICATIONS, payload).then((res) => {
        if (res.status === 500) {
          this._vm.$toast({
            component: ToastificationContent,
            props: {
              title: "حدث خطأ أثناء تنفيذ العملية",
              text: res.data.message,
              icon: "CheckSquareIcon",
              variant: "danger",
              timeout: 10000,
            },
          });
        } else dispatch("handleResponse", res);
      });
      commit("setWorking", false);
    },

    async deleteClassification({ commit, dispatch }, id) {
      commit("setLoading", true);
      await api.delete(endpoints.NGO_CLASSIFICATIONS_BY_ID(id)).then((res) => {
        dispatch("handleResponse", res);
      });
    },
    async deleteService({ commit, dispatch }, id) {
      commit("setLoading", true);
      await api.delete(endpoints.NGO_SERVICE_BY_ID(id)).then((res) => {
        dispatch("handleResponse", res);
      });
    },
    async updateClassification({ commit, dispatch }, payload) {
      commit("setWorking", true);
      await api
        .put(endpoints.NGO_CLASSIFICATIONS + "/" + payload.id, payload)
        .then((res) => {
          dispatch("handleResponse", res);
        });
      commit("setWorking", false);
    },
    handleResponse({ dispatch, commit }, res) {
      if (res.status > 399 && res.status <= 500) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",

            variant: "danger",
          },
        });
        commit("setWorking", false);
        commit("setLoading", false);
      } else {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",

            variant: "success",
          },
        });
        dispatch("fetchServicesAndClassifications");
      }
    },
  },
};
